import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const VisioneSection = () => {
  const { t } = useTranslation();
  const left = useScrollAnimation();
  const right = useScrollAnimation({ threshold: 0.15 });

  const visioneTitleLines = t('visione.title').split('\n');

  return (
    <section id="visione" className="bg-ivory-50 overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[680px]">

          {/* Left: Large Portrait Image — flush, no padding */}
          <div
            ref={left.ref}
            className={`fade-in-up ${left.isVisible ? 'visible' : ''} relative order-2 lg:order-1`}
          >
            <img
              src="https://static.readdy.ai/image/13e0fae89bbbd02d36954a6d83bda5fb/37c5be6a6879f70434df54eec6b878dd.jpeg"
              alt="Ines Felicity Di Nallo — Agente Immobiliare Marche"
              className="w-full h-full object-cover object-top"
              style={{ minHeight: '500px' }}
              title="Ines Felicity Di Nallo — Agente Immobiliare Marche borghi storici"
            />
            {/* Gold accent corner */}
            <div className="absolute bottom-8 right-8 w-20 h-20 border border-gold-300 opacity-50 pointer-events-none" />
          </div>

          {/* Right: All text content stacked */}
          <div
            ref={right.ref}
            className={`fade-in-up stagger-2 ${right.isVisible ? 'visible' : ''} order-1 lg:order-2 flex flex-col justify-center px-8 md:px-14 lg:px-16 xl:px-24 py-16 lg:py-20`}
          >
            {/* Overline */}
            <p className="font-sans text-xs tracking-widest2 uppercase text-terracotta-300 mb-5">
              {t('visione.overline')}
            </p>

            {/* Title */}
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-anthracite-800 font-light leading-tight mb-7">
              {visioneTitleLines.map((line, i) => (
                <span key={i}>
                  {i === 0 ? <em className="italic">{line}</em> : line}
                  {i < visioneTitleLines.length - 1 && <br />}
                </span>
              ))}
            </h2>

            {/* Body text */}
            <p className="font-sans text-sm md:text-base text-anthracite-500 leading-relaxed mb-8">
              {t('visione.text')}
            </p>

            {/* Divider */}
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-px bg-gold-300" />
              <span className="font-sans text-xs tracking-widest text-gold-300 uppercase">Marche Casa, your dream home</span>
            </div>

            {/* Bio Card — inline on the right, no detachment */}
            <div className="bg-white border border-terracotta-100 rounded-lg p-6">
              <div className="flex items-start gap-4 mb-4">
                <div className="flex-1">
                  <h3 className="font-serif text-xl text-anthracite-800 font-medium mb-0.5">
                    {t('visione.ines.name')}
                  </h3>
                  <p className="font-sans text-xs tracking-widest uppercase text-terracotta-300">
                    {t('visione.ines.role')}
                  </p>
                </div>
              </div>
              <p className="font-sans text-sm text-anthracite-500 leading-relaxed mb-5">
                {t('visione.ines.bio')}
              </p>
              <div className="flex flex-wrap gap-2">
                {(['visione.ines.badge.license', 'visione.ines.badge.unibo', 'visione.ines.badge.languages'] as const).map((key) => (
                  <span
                    key={key}
                    className="font-sans text-xs px-3 py-1.5 bg-ivory-100 text-anthracite-600 rounded-full border border-ivory-200"
                  >
                    {t(key)}
                  </span>
                ))}
              </div>
            </div>
          </div>

        </div>

    </section>
  );
};

export default VisioneSection;
